import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchModelDevices(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/model-devices', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchModelDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/model-devices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addModelDevice(ctx, model) {
      return new Promise((resolve, reject) => {
        axios
          .post('/model-devices', model)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateModelDevice(ctx, model) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/model-devices/${model.id}`, model)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteModelDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/model-devices/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    exportModelDevice(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/model-devices/export', { params: { id } })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
